<template>
    <v-col cols="12" :sm="sm" class="py-0">
        <slot />
    </v-col>
</template>
<script>
export default {
    props: { sm: { type: Number, default: 6 } },
};
</script>
